import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Checkbox,
  Space,
  Typography,
  message,
  Spin,
} from "antd";
import { useForm, useWatch, Controller } from "react-hook-form";
import {
  InputField,
  SelectField,
  DateField,
  ReactSelectField,
} from "../../../../atoms/FormElement";
import { api } from "../../../../../services/api"
import DashboardLayout from "../../../../molecules/DashboardLayout";
import SectionHeader from "../../../../molecules/SectionHeader";
import { PlusCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

var _ = require("lodash");
const { Text, Title } = Typography;

// const defaultVal = {
//   name: '',
//   features: null,
//   menuOptions: [],
// };

const { Paragraph } = Typography;

const RequestAccess = (props) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [features, setFeatures] = useState([]);
  const [menu, setMenu] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm({
    // defaultValues: defaultVal,
  });

  const SelectedMenus: any = useWatch({ control, name: "menuOptions" });

  useEffect(() => {
    const menuList = JSON.parse(window.localStorage.getItem("menu-list"))?.data;
    menuList && setMenu(menuList);
  }, [])


  const onFinish = async (formValue) => {

    setLoader(true);
    setSubmited(true);
    const postJson = {
      menus: formValue?.menuOptions?.map(e => ({ value: e.value, features: formValue?.features?.[e.value] || [] })),
      name: formValue.name
    }
    try {

      await api.createACLGroups(postJson);

      setTimeout(() => {
        reset();
        setLoader(false);
        message.success("Permission added successfully");
        setSubmited(false);
        navigate(-1)
      }, 3000);

    } catch (e) {

      setLoader(false);
      setisError(true);
      setErrorMessage(e.message);

    }
  };


  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <SectionHeader heading="Create ACL Group"
            noBorder={true}
            searchName='Category'
            justifiedItems={true}
            justifyEnd={true}
          // onChange={(e) => {searchTrigger(e)}}
          // exportAction2={onClickExport}
          />
        </Col>
        <Col span={24}>
          <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
            {loader && !isError && (
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Space size={24} className="w-100 text-center" direction="vertical">
                    <Spin size="large" className="ag-fontSize32" />
                    {/* <Paragraph className="ag-default fontWeight600 mb-0">Loading</Paragraph> */}
                  </Space>
                </Col>
              </Row>
            )}
            {!submited ? (
              <>
                <Row gutter={24}>
                  <Col span={8}>
                    <InputField
                      isRequired={true}
                      fieldname="name"
                      label="Name"
                      control={control}
                      iProps={{ placeholder: "Enter Name" }}
                      initValue=""
                      validate={errors.name && "error"}
                      validMessage={errors.name && errors.name.message}
                      rules={{
                        required: "Please enter name",
                      }}
                    />
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={8}>
                    <ReactSelectField
                      isRequired={true}
                      fieldname="menuOptions"
                      label="Menu"
                      control={control}
                      iProps={{
                        placeholder: "Select Menu",
                        isDisabled: !menu.length,
                        isMulti: true,
                      }}
                      // onChange={(resMenu) => {
                      //   if(resMenu) {
                      //     // const currentFeatures = JSON.parse(JSON.stringify(features));
                      //     // const currentMenu = JSON.parse(JSON.stringify(menu));

                      //     // if(!currentFeatures.find(feat => feat.value === resMenu.value)) { 
                      //     //   currentFeatures.push(resMenu)
                      //     //   currentMenu.splice(currentMenu.findIndex(a => a.value === resMenu.value) , 1)
                      //     //   setMenu(currentMenu)
                      //     //   setFeatures(currentFeatures)
                      //     // }
                      //   }
                      // }}
                      rules={{
                        required: "Please select menu",
                      }}
                      initValue=""
                      selectOption={menu} //{menu.length > 0 ? menu.map(e => ({ ...e, features: [] })) : []}
                      validate={errors.menuOptions && "error"}
                      validMessage={
                        errors.menuOptions && errors.menuOptions.message
                      }
                    />
                  </Col>
                </Row>

                {SelectedMenus?.map((item, index) =>
                  item?.features?.length > 0 && (
                    <Row gutter={24} key={index}>
                      <Col span={14}>
                        <Row>
                          <Title level={5}>{item.label}</Title>
                          {/*<CloseOutlined onClick={() => {

                              const currentFeatures = JSON.parse(JSON.stringify(features));
                              const currentMenu = JSON.parse(JSON.stringify(menu));

                              currentFeatures.splice(currentFeatures.findIndex(a => a.value === featValue.value), 1)
                              currentMenu.push(featValue)

                              setFeatures(currentFeatures)
                              setMenu(currentMenu)
                            }} style={{ marginTop: 7, marginLeft: 7, cursor: 'pointer' }} /> */}
                        </Row>

                        <Form.Item
                        >
                          <Controller
                            name={`features[${item.value}]`}
                            control={control}
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                              <Checkbox.Group
                                value={value}
                                ref={ref}
                                onChange={(e) => {
                                  // const deepCopy = JSON.parse(JSON.stringify(permissions));
                                  // deepCopy[featValue.value] = e
                                  // setPermissions(deepCopy)
                                  onChange(e);
                                }}
                              >
                                <Space>
                                  {
                                    item?.features
                                    && item?.features?.length > 0 && item?.features.map((featureValue, key) => <Checkbox value={featureValue} key={key}>{featureValue}</Checkbox>)
                                  }
                                </Space>
                              </Checkbox.Group>
                            )}
                          />
                        </Form.Item>
                      </Col>
                      {/* <Col span={4}>
                            <CloseOutlined />
                          </Col> */}
                    </Row>
                  )
                )
                }

                <Row gutter={24}>
                  <Col>
                    <Button className="ag-green-button" htmlType="submit">
                      Create
                    </Button>
                  </Col>
                </Row>
              </>
            ) : (
              isError && (
                <>
                  <Row gutter={[24, 24]}>
                    <Col span={24}>
                      <Space
                        size={24}
                        className="w-100 text-center"
                        direction="vertical"
                      >
                        <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                        <Paragraph className="ag-error fontWeight600 mb-0">
                          {errorMessage}
                        </Paragraph>
                      </Space>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Button
                        className="ag-gray-button-outline"
                        htmlType="button"
                        onClick={() => {
                          setSubmited(false);
                          setisError(false);
                        }}
                      >
                        Back
                      </Button>
                    </Col>
                  </Row>
                </>
              )
            )}
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default RequestAccess;